@if (content) {
  <icms-outlet
    [components]="content.components"
  [name]="name"></icms-outlet>
}
